// components/SubscriptionBadge.js
// Shows Pro/Free Trial status in the navbar
// Last updated: November 27, 2025

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../hooks/useSubscription';

const SubscriptionBadge = () => {
  const navigate = useNavigate();
  const { isPro, isFreeTrial, isLoading, daysRemaining, subscription } = useSubscription();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 bg-gray-500/10 border border-gray-500/30 rounded-lg px-3 py-1.5">
        <span className="text-lg">💳</span>
        <div className="flex flex-col">
          <span className="text-xs text-gray-400 font-bold leading-tight">Loading...</span>
        </div>
      </div>
    );
  }

  if (isPro) {
    return (
      <div 
        onClick={() => navigate('/subscription')}
        className="flex items-center gap-2 bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/50 rounded-lg px-3 py-1.5 cursor-pointer transition-all duration-200 hover:from-yellow-500/30 hover:to-orange-500/30 hover:border-yellow-500/70 hover:scale-105"
      >
        <span className="text-lg">⭐</span>
        <div className="flex flex-col">
          <span className="text-xs text-yellow-400 font-bold leading-tight">
            Pro Plan
          </span>
          {daysRemaining && daysRemaining <= 7 && (
            <span className="text-[10px] text-orange-400 leading-tight">
              {daysRemaining} days left
            </span>
          )}
        </div>
      </div>
    );
  }

  // Free Trial
  return (
    <div 
      onClick={() => navigate('/pricing')}
      className="flex items-center gap-2 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-lg px-3 py-1.5 cursor-pointer transition-all duration-200 hover:from-blue-500/20 hover:to-cyan-500/20 hover:border-blue-500/50 hover:scale-105 animate-pulse-slow"
    >
      <span className="text-lg">🎯</span>
      <div className="flex flex-col">
        <span className="text-xs text-blue-400 font-bold leading-tight">
          Free Trial
        </span>
        <span className="text-[10px] text-gray-400 leading-tight">
          Click to upgrade
        </span>
      </div>
    </div>
  );
};

export default SubscriptionBadge;